import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import useSetPageTitle from '../../../hooks/useSetPageTitle/useSetPageTitle';

import PageBanner from '../../../common/PageBanner/PageBanner';

import { DEFAULT_IMAGE_ALT_TEXT } from '../../../config/constants/contants';

import bannerImage from '../../../images/vitralii-new.webp';

import styles from './Integrity.module.scss';
import commons from '../../../shared/styles/common.module.scss';

const Integrity = () => {
  const { t } = useTranslation();

  useSetPageTitle({
    pageTitle: `${t('pages.integrity')} - ${t('general.website-name')}`,
  });

  return (
    <div>
      <PageBanner
        imageSrc={bannerImage}
        imageText={DEFAULT_IMAGE_ALT_TEXT}
        title={t('pages.integrity')}
      />
      <div className={classNames(styles.content, commons.container)}>
        <div className={styles.contentValue}>
          <div>
            <h3>Avertizori de interes public/Avertizori de integritate</h3>
            <div>
              <p>
                În sensul{' '}
                <a
                  href='https://legislatie.just.ro/Public/DetaliiDocument/262872'
                  target='_blank'
                  rel='noopener noreferrer'>
                  Legii nr. 361/2022
                </a>{' '}
                privind protecţia avertizorilor în interes public. Avertizorul
                în interes public este o persoană fizică, care efectuează o
                raportare sau divulgă public informaţii referitoare la încălcări
                ale legii, obţinute în context profesional.
              </p>
              <p>
                Persoanele care efectuează raportări privind încălcări ale
                legii, care s-au produs sau care sunt susceptibile să se producă
                în cadrul Muzeului Țării Făgărașului „Valer Literat” au
                posibilitatea să utilizeze fie canalele interne, fie cele
                externe, sau să raporteze la canalele externe după ce le- au
                utilizat pe cele interne, beneficiind în același timp de
                aceleași standard de protecție.
              </p>
            </div>
          </div>
          <div>
            <h3>Raportare internă</h3>
            <div>
              <p>
                Persoanele care raportează încălcări ale legii, care s-au produs
                sau sunt susceptibile să se producă, au la dispoziție
                următoarele modalități de raportare internă:
                <ul>
                  <li>
                    în scris, prin e-mail la adresa de mail{' '}
                    <strong>avertizor@muzeufagaras.com</strong>;
                  </li>
                  <li>
                    personal prin prezența la sediul instituției, prin întâlnire
                    față în față cu persoana desemnată (în scris, cu programare
                    prealabilă efectuată la telefon sau prin e-mail cu persoana
                    desemnată);
                  </li>
                  <li>
                    telefonic cu persoana desemnată la numărul de telefon
                    0368404287;
                  </li>
                  <li>
                    prin corespondență poștală, cu condiția obligatorie ca
                    plicul să fie sigilat și marcat confidențial, cu mențiunea
                    „Raportare privind încălcări ale legii, conform Legii
                    361/2022”, la adresa Făgăraș, str. Mihai Viteazul, nr. 1.În
                    situația în care se va transmite prin Compartimentul
                    secretariat, resurse umane, plicul nu va fi deschis, acesta
                    înregistrându-se, prin aplicare pe plic a număruui de
                    înregistrare și va fi înmânat persoanei responsabile.
                  </li>
                </ul>
              </p>
              <p>
                Pentru sesizările formulate în scris se va utiliza formularul{' '}
                <i>Raportare privind încălcări ale legii</i>{' '}
                <a href='https://cetateafagarasului.com/wp-content/uploads/Formular-Raportare-privind-incalcari-ale-legii.doc'>
                  (.doc)
                </a>
                .
              </p>
            </div>
          </div>
          <div>
            <h3>Raportare externă</h3>
            <div>
              <p>
                Persoanele care aleg să se adreseze pe canalul extern - Agenția
                Națională de Integritate - pentru a raporta încălcări ale legii,
                o pot face prin următoarele modalități:
                <ul>
                  <li>
                    online, pe platforma avertizori{' '}
                    <a
                      href='https://avertizori.integritate.eu'
                      target='_blank'
                      rel='noopener noreferrer'>
                      https://avertizori.integritate.eu
                    </a>
                    ;
                  </li>
                  <li>
                    prin e-mail la adresa{' '}
                    <strong>avertizari@integritate.eu</strong>;
                  </li>
                  <li>telefonic, la numărul 0372.069.869;</li>
                  <li>
                    Prin intermediul serviciilor poștalela adresa ANI din
                    Bulevardul Lascăr Catargiu nr. 15, Cod poștal 010661, Sector
                    1, București - România - În atenția Direcției Avertizori în
                    interes public.
                  </li>
                </ul>
              </p>
              <p>
                Raportarea care nu cuprinde numele, prenumele, datele de contact
                sau semnătura avertizorului în interes public se examinează și
                se soluționează în măsura în care conține indicii referitoare la
                încălcări ale legii, în conformitate cu prevederile art. 6
                punctul 2 din Legea nr. 361/2002.
              </p>
            </div>
          </div>
          <div>
            <p>
              <a href='https://cetateafagarasului.com/wp-content/uploads/Plan-integritate-privind-SNA-2021-2025.pdf'>
                Plan integritate privind SNA 2021-2025
              </a>
            </p>
            <p>
              <a href='https://cetateafagarasului.com/wp-content/uploads/Raport-evaluare-implementare-legea-544-din-2001.pdf'>
                Raport evaluare implementare legea 544 din 2001
              </a>
            </p>
            <p>
              <a href='https://cetateafagarasului.com/wp-content/uploads/Declaratie-privind-asumarea-agendei-de-integritate.pdf'>
                Declaratie privind asumarea agendei de integritate
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Integrity;
